import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PurchaseCardFeaturesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${Spacing.S24};
  padding-top: ${Spacing.S24};
  border-top: 1px solid ${Color.Grey150};
`

export const HeaderWrapper = styled.div`
  margin-bottom: ${Spacing.S24};
`

export const FooterWrapper = styled.div`
  margin-top: ${Spacing.S16};
`
